"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tag_1 = require("./_Tag");
var _MetricsAndOperator_1 = require("./_MetricsAndOperator");
exports._MetricsFilter = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Tag: {
            shape: _Tag_1._Tag
        },
        And: {
            shape: _MetricsAndOperator_1._MetricsAndOperator
        }
    }
};
//# sourceMappingURL=_MetricsFilter.js.map